import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgClass } from '@angular/common';

import { ModalsService, WarningInfo, DialogAction, ConfirmableActions } from '../../services/modals.service';

@Component({
  selector: 'app-warnings',
  templateUrl: './warnings.component.html',
  styleUrls: ['./warnings.component.scss']
})
export class WarningsComponent implements OnInit {
  private isOpened = false;
  private reason = 'Default';
  private guidense = 'Default';
  private action: ConfirmableActions;
  private buttonOneName: string;
  private buttonTwoName: string;

  constructor(
    private modals: ModalsService,
  ) { }

  ngOnInit() {
    this.modals.openModalEvent.subscribe((info: WarningInfo) => {
      this.isOpened = info.state;
      if (this.isOpened) {
        this.reason = info.reason;
        this.guidense = info.guidense;
        this.action = info.actionType;
        this.buttonOneName = namesOfButtons[info.actionType].one;
        this.buttonTwoName = namesOfButtons[info.actionType].two;
      }
    });
  }

  confirm() {
    this.modals.closeModalEvent.emit({action: this.action, isConfirmed: true});
  }

  decline() {
    this.modals.closeModalEvent.emit({action: this.action, isConfirmed: false});
  }

  isDialog(): boolean {
    return this.action !== ConfirmableActions.None;
  }
}

const namesOfButtons = {
  none: {
    one: 'Ok',
    two: 'You dont see me'
  },
  logout: {
    one: 'No',
    two: 'Yes'
  },
  delete: {
    one: 'Cancel',
    two: 'Delete'
  },
  deleteSelected: {
    one: 'Cancel',
    two: 'Delete'
  }
};



// WEBPACK FOOTER //
// ./src/app/modals/warnings/warnings.component.ts